import React, { useState, useEffect } from 'react';
import _ from 'underscore';
import { ObservableDataSource } from '../observable/observable-data-source';
import { subscribeAll } from '../observable/subscribe-all';
import { useReportApiCalls } from '../report-api-calls';
import { loadingReportsDataSource } from './loading-reports';

export const recentReportsDataSource = new ObservableDataSource();

const initialize = _.once((reportApiCalls) => {
  recentReportsDataSource.makeCall = reportApiCalls.getRecentReports;
});


// Custom hook for function component
export function useRecentReports() {
  const [data, setData] = useState();

  initialize(useReportApiCalls());

  useEffect(
    () => {
      let isMounted = true;
      const subscription = subscribeAll([recentReportsDataSource, loadingReportsDataSource], (([recentReportsResponse, loadingReports]) => {
        if (isMounted && recentReportsResponse) {
          const merged = [...recentReportsResponse.value];

          if (loadingReports) {
            loadingReports.forEach((loadingReport) => {
              const { Id = 0, ReportType } = loadingReport;
              const findResult = _.findWhere(merged, { Id, ReportType });

              if (findResult) {
                findResult.State = 'InProgress';
              } else {
                merged.unshift({ ...loadingReport, State: 'InProgress' });
              }
            });
          }

          const result = {
            ...recentReportsResponse,
            value: merged,
          };

          setData(result);
        }
      }));

      return function cleanup() {
        isMounted = false;
        subscription.unsubscribe();
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [] // only trigger the effect on componentDidMount
  );

  return data;
}


// HoC for class component
export function withRecentReports(Comp) {
  return function CompWrapper(props) {
    const data = useRecentReports();

    return <Comp {...props} recentReports={data} />;
  };
}
